import type { Ref } from 'vue'
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';

interface IUseCreateQuestionModal {
  product: Ref<IProduct | undefined>,
  isCreateQuestionModalOpen: Ref<boolean>;
  openCreateQuestionModal: (_product: IProduct) => void;
  closeCreateQuestionModal: () => void;
}

export const useCreateQuestionModal = (): IUseCreateQuestionModal => {
  const product = useState<IProduct | undefined>('product', () => undefined);
  const isCreateQuestionModalOpen = useState<boolean>('isCreateQuestionModalOpen', () => false);

  const openCreateQuestionModal = (_product: IProduct) => {
    document.body.style.overflow = "hidden";
    product.value = _product;
    isCreateQuestionModalOpen.value =  true;
  }
  const closeCreateQuestionModal = () => {
    document.body.style.overflow = "";
    product.value = undefined;
    isCreateQuestionModalOpen.value = false;
  }
  return {
    product,
    isCreateQuestionModalOpen,
    openCreateQuestionModal,
    closeCreateQuestionModal
  }
}

